// extracted by mini-css-extract-plugin
export default {"group":"Group_group__HLbW1","title":"Group_title__LPh3i"};